import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import MapIcon from '@mui/icons-material/Map';
import { Chip, colors, IconButton, Stack, Tooltip, Typography } from '@mui/material';
import { GridColDef, } from '@mui/x-data-grid-premium';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { format } from 'date-fns-tz';
import CarrierCompanySelector from 'src/components/selectors/CarrierCompanySelector';
import DriverNameSelector from 'src/components/selectors/DriverNameSelector';
import HierarcheyLevelSelector from 'src/components/selectors/HierarcheyLevelSelector';
import datetimeDecorator from 'src/decorators/datetime.decorator';
import numberDecorator from 'src/decorators/number.decorator';
import { OrderResponseEntity, OrderResponseEntityWithNotAllocReason } from 'src/entities/Order.response.entity';
import { OrderAssignment, OrderBillingPaymentAmount } from 'src/entities/orderEntity';
import { PartnerCompanyEntity } from 'src/entities/PartnerCompanyEntity';
import { PlanningsDriverEntity } from 'src/entities/PlanningsDriver.entity';
import arrayUtil from 'src/utils/array.util';
import numberUtil from 'src/utils/number.util';

import { dataGridUtil } from '../../utils/dataGrid.util';
import { NotAllocReasonPresenter } from '../V2Plans/presenters/NotAllocReasonPresenter';

export const Columns: (
  openLoadingMapDialog: (orderEntity: OrderResponseEntity) => void,
  openUnloadingMapDialog: (orderEntity: OrderResponseEntity) => void,
  driverEntities: PlanningsDriverEntity[],
  updateDriverName: (orderId: number, driverName: string | null) => void,
  partnerCompanyEntities: PartnerCompanyEntity[],
  updateOrderAssignmentColumns: (orderId: number, key: string, value: string) => void,
  localStorageItemPrefix: string,
  rowData: OrderResponseEntityWithNotAllocReason[],
  apiRef: React.MutableRefObject<GridApiPremium>,
) => GridColDef<OrderResponseEntityWithNotAllocReason>[] = (
  openLoadingMapDialog,
  openUnloadingMapDialog,
  driverEntities,
  updateDriverName,
  partnerCompanyEntities,
  updateOrderAssignmentColumns,
  localStorageItemPrefix,
  rowData,
  apiRef,
) => {
  const getWidth = (name: string, width: number) => {
    const maybeWidth: number = dataGridUtil.getSavedColumnWidth(localStorageItemPrefix, name);

    return maybeWidth || width;
  };
  const parsedOrderLoadingSpecifiedTimes = (data: OrderResponseEntity) => {
    const maybe: {
      start_at: string | null;
      end_at: string | null;
    }[] = JSON.parse(data.order_loading_specified_json) as {
      start_at: string | null;
      end_at: string | null;
    }[];

    return maybe.filter((d) => !!d.start_at && !!d.end_at);
  };
  const parsedOrderUnloadingSpecifiedTimes = (data: OrderResponseEntity) => {
    const maybe: {
      start_at: string | null;
      end_at: string | null;
    }[] = JSON.parse(data.order_unloading_specified_json) as {
      start_at: string | null;
      end_at: string | null;
    }[];

    return maybe.filter((d) => !!d.start_at && !!d.end_at);
  };
  const parseOrderBillingAmount = (data: OrderResponseEntity) => {
    const parsed: OrderBillingPaymentAmount = data.order_billing_amount_json
      ? JSON.parse(data.order_billing_amount_json) as OrderBillingPaymentAmount : null;
    return parsed;
  };
  const parseOrderPaymentAmount = (data: OrderResponseEntity) => {
    const parsed: OrderBillingPaymentAmount = data.order_payment_amount_json
      ? JSON.parse(data.order_payment_amount_json) as OrderBillingPaymentAmount : null;
    return parsed;
  };
  const parseOrderAssingment = (data: OrderResponseEntity) => {
    const parsed: OrderAssignment = data.order_assignments_json
      ? JSON.parse(data.order_assignments_json) as OrderAssignment : null;
    return parsed;
  };

  // const calculateSummary = (params: GridGroupingValueGetterParams<GridValidRowModel, number>, valueKey: keyof OrderResponseEntity, converter?: (value: number) => number) => {
  //   console.log('calculateSummary', params);
  //   return '';
  // };
  // const calculateSummary = (params: { rowNode: GridRowTreeNodeConfig, }, valueKey: keyof OrderResponseEntity, converter?: (value: number) => number) => {
  //   const children = rowData.filter((it) => params.rowNode.children.includes(it.id));
  //   if (children.length === 0) return '';
  //   const summary = children.filter((it) => it[valueKey]).reduce((sum, it) => (sum + Number(it[valueKey])), 0);
  //   return converter ? converter(summary) : summary;
  // };

  // const calculateBillingSumary = (params: GridGroupingValueGetterParams<GridValidRowModel, number>, valueKey: keyof OrderBillingPaymentAmount) => {
  //   console.log('calculateBillingSumary', params);
  //   return '';
  // };
  // const calculateBillingSumary = (params: { rowNode: GridRowTreeNodeConfig, }, valueKey: keyof OrderBillingPaymentAmount) => {
  //   const children = rowData.filter((it) => params.rowNode.children.includes(it.id));
  //   if (children.length === 0) return '';
  //   return children.map((order) => {
  //     const amount = parseOrderBillingAmount(order);
  //     if (!amount) return 0;
  //     return Number(amount[valueKey]);
  //   }).filter((it) => it).reduce((sum, it) => (sum + it), 0);
  // };

  // const calculatePaymentSumary = (params: GridGroupingValueGetterParams<GridValidRowModel, number>, valueKey: keyof OrderBillingPaymentAmount) => {
  //   console.log('calculatePaymentSumary', params);
  //   return '';
  // };
  // const calculatePaymentSumary = (params: { rowNode: GridRowTreeNodeConfig, }, valueKey: keyof OrderBillingPaymentAmount) => {
  //   const children = rowData.filter((it) => params.rowNode.children.includes(it.id));
  //   if (children.length === 0) return '';
  //   return children.map((order) => {
  //     const amount = parseOrderPaymentAmount(order);
  //     if (!amount) return 0;
  //     return Number(amount[valueKey]);
  //   }).filter((it) => it).reduce((sum, it) => (sum + it), 0);
  // };

  return ([
    {
      field: 'company_name',
      disableExport: true,
      headerName: '事業所',
      width: 200,
      filterable: false,
      groupable: false,
    },
    {
      field: 'assignment_delivery_id',
      headerName: '配車ID',
      width: 100,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => parseOrderAssingment(it)).filter((it) => it)
        //     .map((it) => it.delivery_id).filter((it) => it)
        //     .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //     .join(',');
        // }
        if (!row.order_assignments_json) return '';
        const orderAssignment = parseOrderAssingment(row);
        if (orderAssignment && orderAssignment.delivery_id) {
          return orderAssignment.delivery_id;
        }
        return '';
      },
      renderCell: (params: { row: OrderResponseEntityWithNotAllocReason, value: string }) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   const fixed = filtered.some((it) => it.order_operations_fixed);
        //   return (
        //     <Stack direction="row" gap={1}>
        //       <Typography>{params.value}</Typography>
        //       {fixed && (<Chip color="info" size="small" label="確定" />)}
        //     </Stack>
        //   );
        // }
        const fixed = params.row.order_operations_fixed;
        return (
          <Stack direction="row" gap={1} alignItems="center" sx={{ height: '100%' }}>
            <Typography>{params.value}</Typography>
            {fixed && (<Chip color="info" size="small" label="確定" />)}
          </Stack>
        );
      },
      groupingValueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_assignments_json) return '';
        const orderAssignment = parseOrderAssingment(row);
        if (orderAssignment && orderAssignment.delivery_id) {
          return orderAssignment.delivery_id;
        }
        if (orderAssignment && orderAssignment.use_ltl) {
          return '路線会社';
        }
        return '未配車';
      },
    },
    {
      field: 'drivers_name',
      headerName: '割当',
      width: 100,
      renderCell: (params: { row: OrderResponseEntityWithNotAllocReason, value: string }) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => {
        //     const assignment = parseOrderAssingment(it);
        //     if (!assignment) return '未割当';
        //     if (!assignment.id || !assignment.planning_license_id) return '未割当';
        //     if (assignment.use_ltl) return '路線会社';
        //     const trucks = JSON.parse(it.truck_json) as { id: number }[];
        //     if (trucks.length === 0 || (trucks.length === 1 && !trucks[0].id)) return '手動配車';
        //     return assignment.assignment;
        //   }).filter((it) => it)
        //   .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //   .join(',');
        // }
        const notAssigned = (
          <>
            <Chip size="small" color="error" label="未割当" sx={{ cursor: 'pointer', width: '100%', justifyContent: 'flex-start', }} />
            {params.row.notAllocReasons?.length > 0 && (
              <NotAllocReasonPresenter
                filteredNotAllocReasons={params.row.notAllocReasons}
                notAllocDeliveries={params.row.notAllocDeliveries}
                notAllocTrucks={params.row.notAllocTrucks}
                notAllocDrivers={params.row.notAllocDrivers}
              />
            )}
          </>
        );

        if (params.value === '未割当') {
          return notAssigned;
        }
        let color = 'success' as 'primary' | 'info' | 'success';
        if (params.value === '路線会社') {
          color = 'primary';
        } else if (params.value === '手動配車') {
          color = 'info';
        }
        const fixed = params.row.order_operations_fixed;
        return <Chip size="small" color={color} label={params.value} sx={{ cursor: (fixed ? '' : 'pointer'), width: '100%', justifyContent: 'flex-start', }} />;
      },
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => {
        //     const assignment = parseOrderAssingment(it);
        //     if (!assignment) return '未割当';
        //     if (!assignment.id || !assignment.planning_license_id) return '未割当';
        //     if (assignment.use_ltl) return '路線会社';
        //     const trucks = JSON.parse(it.truck_json) as { id: number }[];
        //     if (trucks.length === 0 || (trucks.length === 1 && !trucks[0].id)) return '手動配車';
        //     return assignment.assignment;
        //   }).filter((it) => it)
        //   .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //   .join(',');
        // }
        if (!row.order_assignments_json) return '未割当';
        const orderAssignment = parseOrderAssingment(row);
        if (orderAssignment && orderAssignment.planning_license_id === null) return '未割当';
        if (orderAssignment && orderAssignment.use_ltl) {
          return '路線会社';
        }

        const trucks = JSON.parse(row.truck_json) as {
          id: number | null;
          temporary: boolean |null ;
          license_plate_value: string | null;
        }[];

        if (trucks.length === 0 || (trucks.length === 1 && !trucks[0].id)) return '手動配車';

        return trucks.map((truck) => (truck.temporary ? '指定なし' : truck.license_plate_value)).join('／');
      },
      groupingValueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_assignments_json) return '未割当';
        const orderAssignment = parseOrderAssingment(row);
        if (orderAssignment && (!orderAssignment.id || !orderAssignment.planning_license_id)) return '未割当';
        if (orderAssignment && orderAssignment.use_ltl) {
          return '路線会社';
        }

        const trucks = JSON.parse(row.truck_json) as {
          id: number | null;
          temporary: boolean |null ;
          license_plate_value: string | null;
        }[];

        if (trucks.length === 0 || (trucks.length === 1 && !trucks[0].id)) return '手動配車';

        return trucks.map((truck) => (truck.temporary ? '指定なし' : truck.license_plate_value)).join('／');
      },
    },
    {
      field: 'truck_number',
      headerName: '車番',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => parseOrderAssingment(it)).filter((it) => it)
        //     .map((it) => it.truck_number).filter((it) => it)
        //     .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //     .join(',');
        // }

        if (!row.order_assignments_json && !row.truck_json) return '';

        let truckNumber = '';
        if (row.order_assignments_json) {
          const assignments = JSON.parse(row.order_assignments_json) as {
            truck_number: string | null;
          };
          truckNumber = assignments.truck_number;
        }
        if ((!truckNumber || truckNumber === '') && row.truck_json) {
          const trucks = JSON.parse(row.truck_json) as {
            truck_number: string | null;
          }[];
          truckNumber = trucks.map((truck) => truck.truck_number).filter((it) => it).join(',');
        }
        return truckNumber || '';
      },
      editable: true,
      groupable: false,
    },
    {
      field: 'driver_name',
      headerName: 'ドライバー',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => parseOrderAssingment(it)).filter((it) => it)
        //     .map((it) => it.driver_name).filter((it) => it)
        //     .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //     .join(',');
        // }
        if (!row.order_assignments_json && !row.drivers_json) return '';

        let driverName = '';
        if (row.order_assignments_json) {
          const assignments = JSON.parse(row.order_assignments_json) as {
            driver_name: string | null;
          };
          return assignments.driver_name;
        }
        if ((!driverName || driverName === '') && row.drivers_json) {
          const drivers = JSON.parse(row.drivers_json) as {
            name: string | null;
            temporary: boolean | null;
          }[];
          driverName = drivers.map((driver) => (driver.temporary ? '指定なし' : driver.name)).join('／');
        }
        return driverName || '';
      },
      editable: true,
      renderEditCell: (params: { row: OrderResponseEntity, value: string }) => {
        if (params.row.order_operations_fixed) return null;

        return (
          <DriverNameSelector
            driverEntities={driverEntities.map((it) => ({ name: it.name, temporary: it.temporary }))}
            value={params.value}
            id={params.row.id}
            updateDriverName={(id, value) => {
              updateDriverName(id, value);
              void apiRef.current.setEditCellValue({ id: params.row.id, field: 'driver_name', value, });
            }}
            forceFocus
            withLabel={false}
          />
        );
      },
      groupingValueGetter: (params: { row: OrderResponseEntity }) => {
        if (!params.row.order_assignments_json && !params.row.drivers_json) return '(未割当)';

        let driverName = '';
        if (params.row.order_assignments_json) {
          const assignments = JSON.parse(params.row.order_assignments_json) as {
            driver_name: string | null;
          };
          driverName = assignments.driver_name;
        }
        if ((!driverName || driverName === '') && params.row.drivers_json) {
          const drivers = JSON.parse(params.row.drivers_json) as {
            name: string | null;
            temporary: boolean | null;
          }[];
          driverName = drivers.map((driver) => (driver.temporary ? '指定なし' : driver.name)).join('／');
        }
        return driverName || '(未割当)';
      },
    },
    {
      field: 'carrier_company',
      headerName: '運送会社',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => parseOrderAssingment(it)).filter((it) => it)
        //     .map((it) => it.carrier_company).filter((it) => it)
        //     .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //     .join(',');
        // }
        if (!row.order_assignments_json) return '';

        const assignments = JSON.parse(row.order_assignments_json) as {
          carrier_company: string | null;
        };
        return assignments.carrier_company || '';
      },
      editable: true,
      renderEditCell: (params: { row: OrderResponseEntity, value: string }) => (
        <CarrierCompanySelector
          partnerCompanyEntities={partnerCompanyEntities}
          value={params.value}
          id={params.row.id}
          update={((id, value) => {
            updateOrderAssignmentColumns(id, 'carrier_company', value);
          })}
        />
      ),
      groupable: false,
    },
    {
      field: 'operationg_carrier',
      headerName: '実走行会社',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   // グループ化列
        //   const filtered = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (filtered.length === 0) return '';
        //   return filtered.map((it) => parseOrderAssingment(it)).filter((it) => it)
        //     .map((it) => it.operationg_carrier).filter((it) => it)
        //     .reduce((sum: string[], it) => (sum.includes(it) ? sum : sum.concat([it])), [])
        //     .join(',');
        // }
        if (!row.order_assignments_json) return '';

        const assignments = JSON.parse(row.order_assignments_json) as {
          operationg_carrier: string | null;
        };
        return assignments.operationg_carrier || '';
      },
      editable: true,
      renderEditCell: (params: { row: OrderResponseEntity, value: string }) => (
        <CarrierCompanySelector
          partnerCompanyEntities={partnerCompanyEntities}
          value={params.value}
          id={params.row.id}
          update={((id, value) => {
            updateOrderAssignmentColumns(id, 'operationg_carrier', value);
          })}
        />
      ),
      groupable: false,
    },
    {
      field: 'hierarchey_level',
      headerName: '請負階層',
      width: 100,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_assignments_json) return '';

        const assignments = JSON.parse(row.order_assignments_json) as {
          hierarchey_level: string | null;
        };
        if (!assignments.hierarchey_level) return '';

        return `${assignments.hierarchey_level}次請け`;
      },
      editable: true,
      renderEditCell: (params: { row: OrderResponseEntity, value: string }) => (
        <HierarcheyLevelSelector
          value={params.value}
          id={params.row.id}
          update={(id, value) => {
            updateOrderAssignmentColumns(id, 'hierarchey_level', value);
          }}
        />
      ),
      groupable: false,
    },
    {
      field: 'planning_license_name',
      headerName: '配車担当者',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_assignments_json) return '';
        const orderAssignment = parseOrderAssingment(row);
        if (orderAssignment && orderAssignment.planning_license_name) {
          return orderAssignment.planning_license_name;
        }
        return '';
      },
      groupable: false,
    },
    {
      field: 'registered_license_name',
      headerName: '案件登録者',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.registered_license_json) return '';
        const data = JSON.parse(row.registered_license_json) as {
          id: number;
          name: string;
          email: string;
        };
        return data.name || data.email || '';
      },
      groupable: false,
    },
    {
      field: 'encoded_id',
      headerName: 'ID',
      groupable: false,
    },
    {
      field: 'code',
      headerName: '注文コード',
      width: 200,
      groupable: false,
    },
    {
      field: 'shipper_name',
      headerName: '荷主名',
      width: 200
    },
    {
      field: 'shipper_contact_person',
      headerName: '荷主担当者',
      width: 200,
      groupable: false,
    },
    {
      field: 'shipper_phone_number',
      headerName: '荷主電話番号',
      width: 200,
      groupable: false,
    },
    {
      field: 'shipper_email_address',
      headerName: '荷主メールアドレス',
      width: 200,
      groupable: false,
    },
    {
      field: 'loading_name',
      headerName: '積地',
      width: 300
    },
    {
      field: 'loading_address',
      headerName: '積地住所',
      width: 500
    },
    {
      field: 'loading_position',
      headerName: '積地座標',
      disableExport: true,
      width: 250,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (row.loading_latitude && row.loading_longitude) {
          return `${row.loading_latitude}, ${row.loading_longitude}`;
        }
        return '';
      },
      renderCell: (params: { row: OrderResponseEntity }) => {
        if (params.row.loading_latitude && params.row.loading_longitude) {
          return (
            <Stack direction="row" alignContent="center" alignItems="center">
              <Tooltip title="位置を調整します">
                <IconButton onClick={() => openLoadingMapDialog(params.row)}>
                  <MapIcon />
                </IconButton>
              </Tooltip>
              {[params.row.loading_latitude, params.row.loading_longitude].join(', ')}
            </Stack>
          );
        }
        return '';
      },
      groupable: false,
    },
    {
      field: 'loading_latitude',
      headerName: '積地緯度',
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_longitude',
      headerName: '積地経度',
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'order_loading_specified_datetimes_start_date',
      headerName: '積日',
      width: 200,
      type: 'string' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];

        return format(new Date(target.start_at), 'yyyy/MM/dd', { timeZone: 'Asia/Tokyo' });
      },
      groupable: false,
    },
    {
      field: 'loading_start_at1',
      headerName: '積地受付',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];

        return format(new Date(target.start_at), 'HH:mm', { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_end_at1',
      headerName: '積地締切',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = startDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_start_at2',
      headerName: '積地受付②',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 2) { return ''; }

        const base = parsed[0];
        const target = parsed[1];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const fmt = baseDate === startDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.start_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_end_at2',
      headerName: '積地締切②',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 2) { return ''; }

        const base = parsed[0];
        const target = parsed[1];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = baseDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_start_at3',
      headerName: '積地受付③',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 3) { return ''; }

        const base = parsed[0];
        const target = parsed[2];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const fmt = baseDate === startDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.start_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_end_at3',
      headerName: '積地締切③',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_loading_specified_json) { return ''; }
        const parsed = parsedOrderLoadingSpecifiedTimes(row);

        if (parsed?.length < 3) { return ''; }

        const base = parsed[0];
        const target = parsed[2];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = baseDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'loading_staying_minutes',
      headerName: '積地作業分数',
      width: 80,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.loading_staying_seconds) return '';
        return row.loading_staying_seconds / 60;
      },
      groupable: false,
    },
    {
      field: 'unloading_name',
      headerName: '降地名称',
      width: 300,
    },
    {
      field: 'unloading_address',
      headerName: '降地住所',
      width: 500,
    },
    {
      field: 'unloading_position',
      headerName: '降地座標',
      disableExport: true,
      width: 250,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (row.unloading_latitude && row.unloading_longitude) {
          return `${row.unloading_latitude}, ${row.unloading_longitude}`;
        }
        return '';
      },
      renderCell: (params: { row: OrderResponseEntity }) => {
        if (params.row.unloading_latitude && params.row.unloading_longitude) {
          return (
            <Stack direction="row" alignContent="center" alignItems="center">
              <Tooltip title="位置を調整します">
                <IconButton onClick={() => openUnloadingMapDialog(params.row)}>
                  <MapIcon />
                </IconButton>
              </Tooltip>
              {[params.row.unloading_latitude, params.row.unloading_longitude].join(', ')}
            </Stack>
          );
        }
        return '';
      },
      groupable: false,
    },
    {
      field: 'unloading_latitude',
      headerName: '降地緯度',
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_longitude',
      headerName: '降地経度',
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'order_unloading_specified_datetimes_start_date',
      headerName: '降日',
      width: 200,
      type: 'string' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];

        return format(new Date(target.start_at), 'yyyy/MM/dd', { timeZone: 'Asia/Tokyo' });
      },
      groupable: false,
    },
    {
      field: 'unloading_start_at',
      headerName: '降地受付',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];

        return format(new Date(target.start_at), 'HH:mm', { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_end_at',
      headerName: '降地締切',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 1) { return ''; }

        const target = parsed[0];
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = startDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_start_at2',
      headerName: '降地受付②',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 2) { return ''; }

        const base = parsed[0];
        const target = parsed[1];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const fmt = baseDate === startDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.start_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_end_at2',
      headerName: '降地締切②',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 2) { return ''; }

        const base = parsed[0];
        const target = parsed[1];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = baseDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_start_at3',
      headerName: '降地受付③',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 3) { return ''; }

        const base = parsed[0];
        const target = parsed[2];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const startDate = datetimeDecorator.toYyyyMmDd(new Date(target.start_at), '/');
        const fmt = baseDate === startDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.start_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_end_at3',
      headerName: '降地締切③',
      width: 80,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.order_unloading_specified_json) { return ''; }
        const parsed = parsedOrderUnloadingSpecifiedTimes(row);

        if (parsed?.length < 3) { return ''; }

        const base = parsed[0];
        const target = parsed[2];
        const baseDate = datetimeDecorator.toYyyyMmDd(new Date(base.start_at), '/');
        const endDate = datetimeDecorator.toYyyyMmDd(new Date(target.end_at), '/');
        const fmt = baseDate === endDate ? 'HH:mm' : 'yyyy/MM/dd HH:mm';

        return format(new Date(target.end_at), fmt, { timeZone: 'Asia/Tokyo' });
      },
      filterable: false,
      sortable: false,
      groupable: false,
    },
    {
      field: 'unloading_staying_minutes',
      headerName: '降地作業分数',
      width: 80,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.unloading_staying_seconds) return '';
        return row.unloading_staying_seconds / 60;
      },
      groupable: false,
    },
    {
      field: 'item_count',
      headerName: '数量',
      width: 80,
      type: 'number' as const,
      groupable: false,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (rowNode.isAutoGenerated) {
        //   return calculateSummary(params, 'item_count');
        // }
        if (row.item_count === 0) {
          return null;
        }
        return row.item_count;
      },
    },
    {
      field: 'item_packing_style',
      headerName: '荷姿',
      width: 80,
      type: 'number' as const,
      groupable: false,
    },
    {
      field: 'item_total_weight_kg',
      headerName: '総重量',
      width: 80,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (rowNode.isAutoGenerated) {
        //   return calculateSummary(params, 'item_total_weight_for_calculation', numberUtil.convertFromGramToKg);
        // }
        if (!row.item_total_weight_for_calculation && row.item_total_weight_for_calculation === 0) return null;
        if (!row.item_total_weight_for_calculation && row.item_total_weight_for_calculation !== 0) return '';

        return numberUtil.convertFromGramToKg(row.item_total_weight_for_calculation);
      },
      valueFormatter: (value: number) => {
        if (!value) return null;
        if (!value && value !== 0) return '';
        if (value === 0) return '0kg';

        return numberDecorator.toRoundedUnit(value, 'kg', 1, '');
      },
      groupable: false,
    },
    {
      field: 'item_total_volume_m3',
      headerName: '総体積',
      width: 80,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (rowNode.isAutoGenerated) {
        //   return calculateSummary(params, 'item_total_volume_mm3', numberUtil.convertFromMm3ToM3);
        // }
        if (!row.item_total_volume_mm3) return '';

        return numberUtil.convertFromMm3ToM3(row.item_total_volume_mm3);
      },
      valueFormatter: (value: number) => {
        if (!value) return '';

        return numberDecorator.toRoundedUnit(value, 'm³', 10, '');
      },
      groupable: false,
    },
    {
      field: 'item_name',
      headerName: '品名',
      width: 80,
      groupable: false,
    },
    {
      field: 'item_klass',
      headerName: '輸送区分',
      width: 80,
      groupable: false,
    },
    {
      field: 'item_handling_of_cargo_style',
      headerName: '荷扱い',
      width: 80,
      groupable: false,
    },
    {
      field: 'item_can_be_mixed',
      headerName: '混載可否',
      valueGetter: (_, row: OrderResponseEntity) => (row.item_can_be_mixed ? '可' : '不可'),
      renderCell: (params: { row: OrderResponseEntity }) => (
        params.row.item_can_be_mixed
          ? <CheckIcon style={{ color: colors.grey[500] }} /> : <CloseIcon style={{ color: colors.grey[500] }} />
      ),
      width: 80,
      type: 'boolean' as const,
      groupable: false,
    },
    {
      field: 'designated_truck_klasses',
      headerName: '車両タイプ',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_klasses) { return ''; }
        return params.row.designated_truck_klasses.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_car_models',
      headerName: '指定車種',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_car_models) { return ''; }
        return params.row.designated_truck_car_models.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_loading_platform_heights',
      headerName: '荷台高',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_loading_platform_heights) { return ''; }
        return params.row.designated_truck_loading_platform_heights.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_loading_platform_widths',
      headerName: '荷台幅',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_loading_platform_widths) { return ''; }
        return params.row.designated_truck_loading_platform_widths.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_loading_platform_lengths',
      headerName: '荷台長',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_loading_platform_lengths) { return ''; }
        return params.row.designated_truck_loading_platform_lengths.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_floor_specifications',
      headerName: '床仕様',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_floor_specifications) { return ''; }
        return params.row.designated_truck_floor_specifications.join(',');
      },
      groupable: false,
    },
    {
      field: 'designated_truck_features',
      headerName: '指定装置・特徴',
      width: 80,
      valueFormatter: (value: string[]) => { // CSVに出力する場合
        if (!value || value.length < 2) { return value?.join(','); }
        return `"${value.join(',')}"`;
      },
      renderCell: (params: { row: OrderResponseEntity }) => { // 画面に表示する場合
        if (!params.row.designated_truck_features) { return ''; }
        return params.row.designated_truck_features.join(',');
      },
      groupable: false,
    },
    {
      field: 'order_billing_amount_total',
      headerName: '請求金額合計',
      width: 100,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   const children = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (children.length === 0) return '';
        //   return children.map((order) => {
        //     const amount = parseOrderBillingAmount(order);
        //     if (!amount) return 0;
        //     const numKeys = Object.keys(amount).filter((it) => !['id', 'ancillary_content'].includes(it));
        //     const values = numKeys.map((it) => Number(amount[it])).filter((it) => it);
        //     if (values.length === 0) return 0;
        //     return values.reduce((sum, it) => (sum + (it || 0)));
        //   }).filter((it) => it).reduce((sum, it) => (sum + it), 0);
        // }
        const amount = parseOrderBillingAmount(row);
        if (!amount) return '';

        const numKeys = Object.keys(amount).filter((it) => !['id', 'ancillary_content'].includes(it));
        const values = numKeys.map((it) => Number(amount[it])).filter((it) => it);
        if (values.length === 0) return '';
        return values.reduce((sum, it) => (sum + (it || 0)));
      },
      groupable: false,
    },
    {
      field: 'order_billing_amount_basic_fee_yen',
      headerName: '請求 基本運賃',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'basic_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.basic_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.basic_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_surcharge_fee_yen',
      headerName: '請求 サーチャージ料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'surcharge_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.surcharge_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.surcharge_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_relay_fee_yen',
      headerName: '請求 中継料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'relay_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.relay_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.relay_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_highway_fee_yen',
      headerName: '請求 高速代金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'highway_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.highway_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.highway_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_loading_fee_yen',
      headerName: '請求 積込料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'loading_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.loading_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.loading_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_ancillary_fee_yen',
      headerName: '請求 付帯作業料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'ancillary_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.ancillary_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.ancillary_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_waiting_time_fee_yen',
      headerName: '請求 待機料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'waiting_time_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.waiting_time_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.waiting_time_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_unloading_fee_yen',
      headerName: '請求 取卸料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'unloading_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.unloading_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.unloading_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_expenses_fee_yen',
      headerName: '請求 諸経費',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculateBillingSumary(params, 'expenses_fee_yen');
      //   }
      //   return parseOrderBillingAmount(params.row)?.expenses_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.expenses_fee_yen,
      groupable: false,
    },
    {
      field: 'order_billing_amount_ancillary_content',
      headerName: '請求 付帯作業備考',
      valueGetter: (_, row: OrderResponseEntity) => parseOrderBillingAmount(row)?.ancillary_content,
      renderCell: (params: { row: OrderResponseEntity }) => (
        <Tooltip title={parseOrderBillingAmount(params.row)?.ancillary_content}>
          <span>
            {parseOrderBillingAmount(params.row)?.ancillary_content}
          </span>
        </Tooltip>
      ),
      width: 200,
      groupable: false,
    },
    {
      field: 'order_payment_amount_total',
      headerName: '支払金額合計',
      width: 100,
      type: 'number' as const,
      valueGetter: (_, row: OrderResponseEntity) => {
        // if (params.rowNode.isAutoGenerated) {
        //   const children = rowData.filter((it) => params.rowNode.children.includes(it.id));
        //   if (children.length === 0) return '';
        //   return children.map((order) => {
        //     const amount = parseOrderPaymentAmount(order);
        //     if (!amount) return 0;
        //     const numKeys = Object.keys(amount).filter((it) => !['id', 'ancillary_content'].includes(it));
        //     const values = numKeys.map((it) => Number(amount[it])).filter((it) => it);
        //     if (values.length === 0) return 0;
        //     return values.reduce((sum, it) => (sum + it), 0);
        //   }).filter((it) => it).reduce((sum, it) => (sum + it), 0);
        // }
        const amount = parseOrderPaymentAmount(row);
        if (!amount) return '';

        const numKeys = Object.keys(amount).filter((it) => !['id', 'ancillary_content'].includes(it));
        const values = numKeys.map((it) => Number(amount[it])).filter((it) => it);
        if (values.length === 0) return '';
        return values.reduce((sum, it) => (sum + it), 0);
      },
      groupable: false,
    },
    {
      field: 'order_payment_amount_basic_fee_yen',
      headerName: '支払 基本運賃',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'basic_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.basic_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.basic_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_surcharge_fee_yen',
      headerName: '支払 サーチャージ料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'surcharge_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.surcharge_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.surcharge_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_relay_fee_yen',
      headerName: '支払 中継料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'relay_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.relay_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.relay_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_highway_fee_yen',
      headerName: '支払 高速代金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'highway_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.highway_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.highway_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_loading_fee_yen',
      headerName: '支払 積込料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'loading_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.loading_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.loading_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_ancillary_fee_yen',
      headerName: '支払 付帯作業料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'ancillary_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.ancillary_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.ancillary_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_waiting_time_fee_yen',
      headerName: '支払 待機料金',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'waiting_time_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.waiting_time_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.waiting_time_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_unloading_fee_yen',
      headerName: '支払 取卸料',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'unloading_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.unloading_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.unloading_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_expenses_fee_yen',
      headerName: '支払 諸経費',
      width: 80,
      type: 'number' as const,
      // valueGetter: (params: { row: OrderResponseEntity, rowNode: GridRowTreeNodeConfig, }) => {
      //   if (params.rowNode.isAutoGenerated) {
      //     return calculatePaymentSumary(params, 'expenses_fee_yen');
      //   }
      //   return parseOrderPaymentAmount(params.row)?.expenses_fee_yen;
      // },
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.expenses_fee_yen,
      groupable: false,
    },
    {
      field: 'order_payment_amount_ancillary_content',
      headerName: '支払 付帯作業備考',
      valueGetter: (_, row: OrderResponseEntity) => parseOrderPaymentAmount(row)?.ancillary_content,
      renderCell: (params: { row: OrderResponseEntity }) => (
        <Tooltip title={parseOrderPaymentAmount(params.row)?.ancillary_content}>
          <span>
            {parseOrderPaymentAmount(params.row)?.ancillary_content}
          </span>
        </Tooltip>
      ),
      width: 200,
      groupable: false,
    },
    {
      field: 'memo',
      headerName: '備考',
      width: 300,
      renderCell: (params: { row: OrderResponseEntity }) => {
        if (!params.row.memo) return '';

        const val = params.row.memo
          .trim()
          .split('\n')
          .flatMap((str) => arrayUtil.sliceByNumber(str.split(''), 20).map((s, idx) => (
            <li
              key={[params.row.id, idx].join('_')}
              style={{
                listStyle: 'none'
              }}
            >
              {s}
            </li>
          )));

        return (
          <ul
            style={{
              padding: 0,
              margin: 0,
              height: '100%',
            }}
          >
            {val}
          </ul>
        );
      },
      groupable: false,
    },
    {
      field: 'allowed_trucks_license_plate_value',
      headerName: '指定トラック',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => { // 画面に表示する場合
        if (!row.allowed_trucks_json) { return ''; }

        const maybeTrucks = JSON.parse(row.allowed_trucks_json) as {
          id: number | null;
          name: string | null;
        }[];

        const trucks = maybeTrucks.filter((d) => !!d.id && !!d.name);

        if (trucks.length < 1) { return ''; }

        return trucks.map((obj) => obj.name).join(',');
      },
      groupable: false,
    },
    {
      field: 'denied_drivers_name',
      headerName: 'NGドライバー',
      width: 200,
      valueGetter: (_, row: OrderResponseEntity) => {
        if (!row.denied_drivers_json) return '';

        const maybeDrivers = JSON.parse(row.denied_drivers_json) as {
          id: number | null;
          name: string | null;
        }[];

        const drivers = maybeDrivers.filter((d) => !!d.id && !!d.name);

        return drivers.map((obj) => obj.name).join(',');
      },
      groupable: false,
      }
  ] as GridColDef<OrderResponseEntityWithNotAllocReason>[]).map((it) => ({
    ...it,
    width: getWidth(it.field, it.width || 50)
  }));
};
